export default __webpack_public_path__ + "static/media/318.bf7e9018.jpg";